export const resetState = () => ({
    type: "RESET_STATE",
});

export const accessToken = (access_token: any) => ({
    type: 'ACCESS_TOKEN',
    payload: access_token,
});

export const menus = (menus: any) => ({
    type: 'MENU',
    payload: menus,
});

export const userName = (user_name: any) => ({
    type: 'USER_NAME',
    payload: user_name,
});

export const userInfo = (user_info: any) => ({
    type: 'USER_INFO',
    payload: user_info,
});

export const notificationUnreadCount = (notification_unread_count: any) => ({
    type: 'NOTIFICATION_COUNT',
    payload: notification_unread_count,
})

export const userEmail = (user_email: any) => ({
    type: 'USER_EMAIL',
    payload: user_email,
});

export const updateProfileImage = (imageUrl: any) => ({
    type: 'UPDATE_PROFILE_IMAGE',
    payload: imageUrl,
});

export const googleApiTime = (googleApiTime: any) => ({
    type: 'GOOGLE_API_TIME',
    payload: googleApiTime,
});

export const firebaseToken = (firebaseToken: any) => ({
    type: 'FIREBASE_TOKEN',
    payload: firebaseToken,
});

export const otpRefId = (refId: any) => ({
    type: 'REF_ID',
    payload: refId,
});

export const forgotPassObj = (forgotPassObj: any) => ({
    type: 'FORGOT_PASS_OBJ',
    payload: forgotPassObj,
});

export const microPhoneStatus = (status: boolean) => ({
    type: 'MICROPHONE_STATUS',
    payload: status,
});

export const language = (status: string) => ({
    type: 'LANGUAGE',
    payload: status,
});